export var timeSegmentMaskKeys = {
  hours: 'hh',
  minutes: 'mm',
  seconds: 'ss',
  milliseconds: 'sss'
};
export var defaultTimeAriaLabels = {
  hours: 'Hours',
  minutes: 'Minutes',
  seconds: 'Seconds',
  milliseconds: 'Milliseconds',
  increase: {
    hours: 'Increase hours',
    minutes: 'Increase minutes',
    seconds: 'Increase seconds',
    milliseconds: 'Increase milliseconds'
  },
  decrease: {
    hours: 'Decrease hours',
    minutes: 'Decrease minutes',
    seconds: 'Decrease seconds',
    milliseconds: 'Decrease milliseconds'
  }
};